import styled, { css } from 'styled-components';

import variables from '../../../styles/variables';

// GENERAL SCREEN STYLES
export const Phase2Screen = styled.div`
  width: 100%;
  height: auto;
  color: ${variables.colorBlack};
`;

export const BladeTitle = styled.h2`
  color: #eb0000;
  width: 100%;
  font-size: 43px;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 0;
  @media screen and (max-width: 768px) {
    font-size: 30px;
  }
`;

export const BladeSubtitle = styled.h3`
  font-size: 18px;
  font-weight: normal;
  line-height: 1.6;
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const InstrText = styled.p`
  font-size: 18px;
  line-height: 1.6;
  @media screen and (max-width: 768px) {
  }
  font-size: 14px;
`;

export const SectionWrapper = styled.div<{ section?: string }>`
  padding: 30px 0;
  &#reserveButton {
    @media screen and (max-width: 768px) {
      display: flex;
      justify-content: center;
    }
  }
  &#captchaWrapper {
    padding: 0;
  }

  ${(props) => props.section === 'dpp'
    && css`
      background-color: #f4f4f4;
      margin-top: 40px;
      border-radius: 10px;
      @media screen and (max-width: 500px) {
        width: 100vw;
        padding-left: calc((100vw - 100%) / 2);
        padding-right: calc((100vw - 100%) / 2);
        margin-left: calc(((100vw - 100%) / 2) * -1);
        border-radius: 0;
      }
    `}
`;

// PERSONAL DETAIL SUMMARY
export const FormTitle = styled.p`
  font-size: 14px;
  margin-bottom: 6px;
`;

export const DetailSummary = styled.p`
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 20px;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

// BUTTON
export const AddToCartButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 250px;
  height: 53px;
  cursor: pointer;
  border: none;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 26px;
  box-shadow:
    0 2px 4px 0 rgba(53, 43, 43, 0.24),
    0 2px 4px 0 rgba(238, 46, 36, 0.49);
  margin: 5px;
  transition: all 0.3s;
  &:hover {
    background: ${variables.colorWhite};
    color: ${variables.colorRed};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  }
  @media screen and (max-width: 768px) {
    width: 60%;
  }
`;

export const GridWrapper = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  grid-template-rows: 1fr;
  grid-template-areas: 'empty reserve spinner';
  align-items: center;
`;

export const ButtonText = styled.div`
  grid-area: reserve;
  justify-self: center;
`;

export const SpinnerWrapper = styled.div`
  grid-area: spinner;
  justify-self: center;
`;

export const Spinner = styled.div`
  width: 25px;
  height: 25px;
  border: ${variables.colorWhite} solid 4px;
  border-right-color: transparent;
  border-radius: 50%;
  animation: rotate-cw;
  animation-duration: 1s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  @keyframes rotate-cw {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const LegalText = styled.p`
  font-size: 12px;
  text-align: center;
`;

// STORE
export const AddressWrapper = styled.div`
  display: inline-block;
  width: 85%;
  height: auto;
  p {
    margin: 0;
  }
`;

export const MarkerWrapper = styled.div`
  display: inline-block;
  height: 30px;
  width: auto;
  margin-right: 25px;
  img {
    width: auto;
    height: 100%;
  }
`;

export const LocationSummaryWrapper = styled.div`
  display: flex;
  align-items: center;
`;

// VALIDATION AREA
export const OptText = styled.p`
  font-size: 11px;
  width: 95%;
  display: inline-block;
  margin-bottom: 0;
`;

export const OptWrapper = styled.div`
  display: flex;
  align-items: center;
  input#optIn {
    margin-right: 10px;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    border: solid 2px #b4b7bd;
    background-color: white;
  }
  a {
    font-size: inherit;
  }
`;

export const ErrorMsg = styled.div`
  color: ${variables.colorRed};
  font-size: 12px;
  &.optInError p {
    color: ${variables.colorRed};
    font-size: 12px;
  }
  &.recaptcha {
    margin-top: 0.5rem;
  }
`;

export const DppContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(3, auto);
`;

export const ImageAndHeadingContainer = styled.div<{ locale?: string }>`
  display: grid;
  grid-template-columns: ${({ locale }) => locale === 'en' ? '30% 9% 39% 22%' : '23% 9% 54% 14%'};
  grid-template-areas: 'empty1 logo heading empty2';
  margin-bottom: 16px;

  @media screen and (max-width: 767px) {
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    margin-left: ${({ locale }) => (locale === 'en' ? '53px' : '0')};
  }

  @media screen and (max-width: 375px) {
    margin-left: 9px;
    margin-bottom: 30px;
  }
`;

export const DppLogoWrapper = styled.div`
  height: 50.6px;
  width: auto;
  margin-top: 6px;
  grid-area: logo;
  img {
    width: auto;
    height: 100%;
  }
`;

export const DppHeadingWrapper = styled.div<{ locale?: string }>`
  grid-area: heading;
  font-size: 25px;
  font-weight: 600;
  line-height: 24px;
  margin-top: 7px;

  @media screen and (max-width: 767px) {
    margin-left: 25px;
    width: ${({ locale }) => (locale === 'en' ? '43%' : '55%')};
  }

  @media screen and (max-width: 500px) {
    font-size: 20px;
    width: 64%;
  }

  @media screen and (max-width: 375px) {
    font-size: 19px;
    width: 100%;
    margin-left: ${({ locale }) => (locale === 'en' ? '25px' : '10px')};
  }
`;

export const DppLabelsContainer = styled.div<{ dppSelected?: boolean }>`
  display: grid;
  grid-template-columns: 17% 0% 43% 0% 40%;
  grid-template-areas: 'add empty1 fee empty2 benefit';
  border: ${({ dppSelected }) => dppSelected
    ? `2px solid ${variables.colorRed}`
    : `2px solid ${variables.colorGreyMedium}`};
  border-radius: 10px;
  align-items: center;
  background-color: #fff;
  margin: 0 50px;
  //padding-top: 15px;

  @media (max-width: 500px) {
    margin: 0;
    grid-template-columns: 30% 70%;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      'add labels1'
      'empty labels2';
  }

  @media screen and (max-width: 375px) {
    grid-template-columns: 30% 70%;
    margin: 0;
  }
`;

export const DppMonthlyPrice = styled.div`
  grid-area: fee;

  p {
    font-size: 14px;
    width: 60%;
    margin: 10px auto;
    strong {
      font-size: 25.2px;
    }
    small {
      font-size: 10px;
      strong {
        font-size: 10px;
      }
    }
  }
  @media (max-width: 500px) {
    grid-area: labels1;
    p {
      width: 73%;
      margin: 10px auto 0;
    }
  }
  @media (max-width: 375px) {
    p {
      width: 79%;
      margin: 10px auto 0 0;
      line-height: 1;
    }
  }
`;

export const DppBenefits = styled.p`
  grid-area: benefit;
  font-size: 13px;
  line-height: 17px;
  font-weight: 600;
  margin: 8px 0 12px 0;
  @media (max-width: 500px) {
    grid-area: labels2;
    width: 73%;
    margin: 0 auto;
    margin-top: -11px;
    text-align: left;
    padding-top: 17px;
    padding-bottom: 10px;
  }
  @media (max-width: 375px) {
    font-size: 12px;
    width: 100%;
  }
`;

export const DppFooter = styled.p`
  margin-top: 20px;
  text-align: center;
  font-size: 12px;
  width: 94%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
  a {
    font-size: 12px;
  }
`;

export const DppDisclaimer = styled.p`
  margin-top: 20px;
  text-align: left;
  font-size: 12px;
  width: 100%;
  margin-bottom: -10px;
  a {
    font-size: 12px;
  }
`;

export const CheckBoxLabel = styled.label`
  grid-area: add;
  margin: 0 auto;
  input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
  @media screen and (max-width: 500px) {
    grid-row-start: 1;
    grid-row-end: 3;
  }
`;

export const FocusWrapper = styled.div`
  display: flex;
  align-items: center;
`;

// Custom checkbox for styling
export const CheckBox = styled.div<{ checked?: boolean }>`
  width: 18px;
  height: 18px;
  flex-shrink: 0;

  display: flex;
  align-items: center;
  border: ${({ checked }) => checked ? 'none' : `solid ${variables.colorGrey} 2px`};
  opacity: 0.8;
  border-radius: 2px;
  &.checked {
    background: ${variables.colorRed};
  }
  /* The checkmark */
  img {
    width: 100%;
    height: 100%;
  }
`;

export const ErrorWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 1rem;
  height: 14px;

  img {
    width: 20px;
    height: 20px;
    margin-right: 7px;
    margin-left: 3px;
  }
`;
